import script from "./CapitalMeg.vue?vue&type=script&setup=true&lang=js"
export * from "./CapitalMeg.vue?vue&type=script&setup=true&lang=js"

import "./CapitalMeg.vue?vue&type=style&index=0&id=2a2f73ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a2f73ce"]])

export default __exports__